import { BehaviorSubject } from "rxjs";
import * as APIModels from "../models";
import { TylerAdminService, UserService } from "../services/ClientService";
import { authenticationService } from "../services/authentication.service";

const meSubject = new BehaviorSubject(JSON.parse(localStorage.getItem("me")!));
const portalSubject = new BehaviorSubject(localStorage.getItem("portal"));

import crypto from "crypto";

const newGuid = () => {
    return [
        Math.floor(Math.random() * 16).toString(16),
        Math.floor(Math.random() * 256).toString(16),
        (Math.random() * 4096) % 256 | 0,
        ((1 << 8) - 1) & Math.floor(Math.random() * 65536),
        Math.floor(new Date().getTime() / 1000).toString(16),
    ].join("-");
};

function retrieveMe(): Promise<void> {
    return new Promise((resolve, reject) => {
        if (portalSubject.getValue()) {
            localStorage.setItem(
                "me",
                JSON.stringify(authenticationService.currentUserValue)
            );
            meSubject.next(
                JSON.stringify(authenticationService.currentUserValue)
            );
            resolve();
            return;
        }
        UserService.me().then(
            (resp) => {
                if (resp.successful && resp.data) {
                    localStorage.setItem("me", JSON.stringify(resp.data));
                    meSubject.next(resp.data);
                } else {
                    //authenticationService.logout();
                }
                resolve();
            },
            (error) => {
                //authenticationService.logout();
                resolve();
            }
        );
    });
}

function removeMe(): void {
    localStorage.removeItem("me");
    meSubject.next(null);
}

function MaybeId(id: (string | undefined) | (string | null)): string {
    return id ?? APIModels.EmptyGuid;
}

export const Globals = {
    retrieveMe,
    removeMe,
    newGuid,
    me: meSubject.asObservable(),
    MaybeId,
    get currentUserValue(): APIModels.User {
        return meSubject.value;
    },
    get portalValue(): string {
        return portalSubject.value!;
    },
};
